import { render, staticRenderFns } from "./OwnerDashboardIndex.vue?vue&type=template&id=223e0e0c&scoped=true&"
import script from "./OwnerDashboardIndex.vue?vue&type=script&lang=ts&"
export * from "./OwnerDashboardIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e0e0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
